<template>
  <div>
    <el-form-item label="发布身份" required label-width="80px">
      <div class="vCenter rangeselect">
        <el-radio class="elradio" v-model="formdapp.identitytype" label="1" :disabled="formdapp.distype==1" @change="setItem">个人身份</el-radio>
        <el-radio class="elradio" v-model="formdapp.identitytype" label="3" @change="setItem">组织身份</el-radio>
      </div>
    </el-form-item>
    <el-form-item v-if="formdapp.identitytype=='3'" label="代表组织" required label-width="80px">
      <el-select
        v-model="formdapp.item"
        placeholder="请选择代表组织"
        :popper-append-to-body="false"
        @change="curOrgChanged"
      >
        <el-option
          v-for="item in orglist"
          :key="item.orgid"
          :label="item.orgname"
          :value="item.orgid"
        ></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>
<script>
export default {
  name: "umIdentity",
  data() {
    return {
      orglist: [],
      orgid: ""
    };
  },
  props: ["formdapp"],
  created() {
    let that = this;
    that.formdapp.item = $UMCore.uncompile("umid");
    $UMCore
      .post("/route.lua", {
        data: JSON.stringify({
          functionname: "userlist_getusermangerrange",
          type: 3,
          umid: $UMCore.uncompile("umid")
        })
      })
      .then(function(response) {
        that.orglist = response.data.mangerlist.orglist;
      })
      .catch(function(error) {
        return false;
      });
  },
  methods: {
    setItem(e) {
      if (e == "1") {
        this.formdapp.item = $UMCore.uncompile("umid");
      } else {
        this.formdapp.item = this.orgid;
      }
    },
    curOrgChanged(e) {
      this.orgid = e;
      this.$emit("selectOrg", e, this.formdapp.identitytype);
    }
  }
};
</script>
<style lang="scss" scoped>
.addlist {
  .rangeselect {
    padding: 14px 0;
  }
}
.rangeselect {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/packages/identity/um-identity.vue